import React from 'react';
import {
    genClassNames,
    LatLng,
    TKGeocodingOptions,
    TKPeliasGeocoder,
    TKRegionResults,
    TKRegionsData,
    TKRoot,
    TKState,
    TKStateUrl,
    TKUIConfig,
    TKUIMapViewProps,
    TKUISettingLink,
    TKUISettingSection,
    TKUITripPlanner,
    TKUtil,
    Environment,
    Env,
    TKDefaultGeocoderNames,
    TKUserProfile,
    TKUIButton,
    TKUIButtonType,
    TKLocation,
    RoutingResultsContext
} from 'tripkit-react';
import { overrideClass } from "tripkit-react/dist/jss/StyleHelper";
import { ReactComponent as LogoTestflight } from "../images/test-flight.svg";
import { ReactComponent as LogoGooglePlay } from "../images/google-play.svg";
import classNames from 'classnames';
import { ReactComponent as IconReport } from '../images/ic-usersnap.svg';
import { ReactComponent as Logo } from "../images/logo-chym.svg";
import leicesterBusesLogo from "../images/logo-leicester-buses.png";
import betterpointsLogo from "../images/logo-betterpoints.png";
import Constants from "tripkit-react/dist/util/Constants";
import OptionsData from 'tripkit-react/dist/data/OptionsData';
import { feedbackTextFromState } from 'tripkit-react/dist/feedback/TKUIReportBtn';
import { TKUIIconName } from 'tripkit-react/dist/service/TKUIIcon';
import bringThePaintLogo from "../images/bringThePaint.png";
import { TKUIModeLocationMarker } from 'tripkit-react/dist/map/TKUIMapLocations';
import FacilityLocation from 'tripkit-react/dist/model/location/FacilityLocation';

interface IProps {
    apiKey: string
}

const hostname = window.location.hostname;
const isBeta = hostname.includes("beta.localhost") || hostname.includes("-beta") || hostname === "localhost";

const regionsFallback = require("./regionsFallback.json");
TKRegionsData.regionsJsonFallback = regionsFallback;

// Force production to enable planned trips tracking.
Environment.setEnvironment(Env.PRODUCTION);

type WhiteLabelId = "chym" | "leicesterbuses" | "uhl";

const TripPlannerApp: React.FunctionComponent<IProps> = (props: IProps) => {

    const analyticsConfig = Environment.isProd() ? {
        google: {
            tracker: {
                trackingId: "G-6MLXJ9NKD1"
            }
        }
    } : undefined;

    /**
     * Start with map on (initViewport) default city (the first one of hardcoded region) until wait for user location.
     * When user location resolves, if it lays inside region bounds, then focus map on it, otherwise do nothing.
     */
    const defaultRegions: TKRegionResults = TKUtil.deserialize(regionsFallback, TKRegionResults);
    const userLocationPromise = (window as any).tKUserLocationPromise ?
        (window as any).tKUserLocationPromise
            .then((userCoords: [number, number]) => LatLng.createLatLng(userCoords[0], userCoords[1]))
            // .then(TKNetworkUtil.delayPromise(4000))
            .then((userLatLng: LatLng) => {
                for (const region of defaultRegions.regions) {
                    if (region.contains(userLatLng)) {
                        return userLatLng;
                    }
                }
                // throw "User location outside bounds."
            })
        : undefined;
    const defaultRegion = defaultRegions.regions[0];
    const defaultCityLatLng = defaultRegion.cities[0];

    const geocodeEarth = new TKPeliasGeocoder({
        server: "https://api.geocode.earth/v1",
        apiKey: "ge-f1af6ef405da7120",
        restrictToBounds: true,
        region: defaultRegion,
        resultsLimit: 5
    });

    const geocodeEarthID = 'geocodeEarth';

    const whiteLabelId: WhiteLabelId =
        hostname.includes("leicesterbuses") ? "leicesterbuses" :
            hostname.includes("uhl") ? "uhl" : "chym";

    let whiteLabelConfigOverride: any = undefined;
    let defaultUserProfile;
    let resetUserProfile: boolean = false;

    switch (whiteLabelId) {
        case 'leicesterbuses':
            whiteLabelConfigOverride = {
                apiKey: "b54b34a5f8dc56af3301ba198d3eebf4",
                theme: {
                    colorPrimary: '#00aeef'
                },
                TKUITripPlanner: {
                    props: (props) => ({
                        renderTopRight: props.landscape ? () => <img src={Constants.DEPLOY_URL + leicesterBusesLogo} style={{ height: '48px' }} />
                            : undefined
                    })
                },
                TKUISidebar: {
                    props: () => ({
                        renderLogo: () => <img src={Constants.DEPLOY_URL + leicesterBusesLogo} style={{ height: '48px' }} />
                    })
                }
            };
            // Get current profile instead creation a new one to avoid resetting the other options given will set resetUserProfile in true;
            defaultUserProfile = OptionsData.instance.get();
            defaultUserProfile.routingQueryParams = { onlyAllowModes: "pt_pub_bus" };
            resetUserProfile = true;
            break;
        case 'uhl':
            whiteLabelConfigOverride = {
                apiKey: "b54b34a5f8dc56af3301ba198d3eebf4",
                theme: {
                    colorPrimary: '#378d23'
                },
                TKUITripPlanner: {
                    props: (props) => ({
                        renderTopRight: props.landscape ? () => <img src={Constants.DEPLOY_URL + leicesterBusesLogo} style={{ height: '48px' }} />
                            : undefined
                    })
                },
                TKUISidebar: {
                    props: () => ({
                        renderLogo: () => <img src={Constants.DEPLOY_URL + leicesterBusesLogo} style={{ height: '48px' }} />
                    })
                }
            };
            defaultUserProfile = new TKUserProfile();
            break;
        default:
            defaultUserProfile = new TKUserProfile();
    }
    defaultUserProfile.transportOptions.setTransportOption("me_car", 2);

    // const isLeicesterBuses = hostname.includes("leicesterbuses");

    // let defaultUserProfile;

    // if (isLeicesterBuses) {
    //     // Get current profile instead creation a new one to avoid resetting the other options given will set resetUserProfile in true;
    //     defaultUserProfile = OptionsData.instance.get();
    //     defaultUserProfile.routingQueryParams = { onlyAllowModes: "pt_pub_bus" };
    // } else {
    //     defaultUserProfile = new TKUserProfile();
    // }
    // defaultUserProfile.transportOptions.setTransportOption("me_car", 2);

    // const leicesterBusesConfigOverride = isLeicesterBuses ?
    //     {
    //         apiKey: "b54b34a5f8dc56af3301ba198d3eebf4",
    //         theme: {
    //             colorPrimary: '#00aeef'
    //         },
    //         TKUITripPlanner: {
    //             props: (props) => ({
    //                 renderTopRight: props.landscape ? () => <img src={Constants.DEPLOY_URL + leicesterBusesLogo} style={{ height: '48px' }} />
    //                     : undefined
    //             })
    //         },
    //         TKUISidebar: {
    //             props: () => ({
    //                 renderLogo: () => <img src={Constants.DEPLOY_URL + leicesterBusesLogo} style={{ height: '48px' }} />
    //             })
    //         }
    //     } : undefined;

    const bringThePaintLocations = [{
        "lat": 52.64112340529459,
        "lng": -1.1301863193511965,
        "timezone": "Australia/Darwin",
        "address": "Gower St 1",
        "region": "UK_Leicester",
        // Need to comment out the id since locationInfo doesn't resolve it by id, this way it looks by lat/lng and at least finds the w3w.        
        // "id": "btp-1",
        "name": "IDLE",
        "facilityType": "Bring-The-Paint",
        "class": "Location"
    },
    {
        "lat": 52.6408678746161,
        "lng": -1.1438629031181338,
        "timezone": "Australia/Darwin",
        "region": "AU_NT_Darwin",
        // "id": "btp-2",
        "address": "Designer Metals, Lock 42",
        "name": "OUST x CAPTAIN",
        "facilityType": "Bring-The-Paint",
        "class": "Location"
    },
    {
        "lat": 52.63673523171425,
        "lng": -1.142159700393677,
        "timezone": "Australia/Darwin",
        "region": "UK_Leicester",
        // "id": "btp-3",
        "address": "Lane7 Rear Wall Leicester",
        "name": "SMT",
        "facilityType": "Bring-The-Paint",
        "class": "Location"
    },
    {
        "lat": 52.63756211707071,
        "lng": -1.1319029331207278,
        "timezone": "Australia/Darwin",
        "region": "UK_Leicester",
        // "id": "btp-4",
        "address": "Haymarket Theatre Steps",
        "name": "CHURCH OF BESTEVER",
        "facilityType": "Bring-The-Paint",
        "class": "Location"
    }].map(locJson => TKUtil.deserialize(locJson, FacilityLocation));

    const config: TKUIConfig = {
        apiKey: props.apiKey,
        theme: {
            colorPrimary: '#006b3d'
        },
        i18n: {
            locale: navigator.language,
            translations: {}
        },
        analytics: analyticsConfig,
        initViewport: { center: defaultCityLatLng, zoom: 13 },
        geocoding: (defaultOptions: TKGeocodingOptions) => {
            const defaultGeocoders = { ...defaultOptions.geocoders };
            delete defaultGeocoders[TKDefaultGeocoderNames.recent];
            return ({
                geocoders: {
                    ...defaultGeocoders,
                    [geocodeEarthID]: geocodeEarth
                },
                maxResults: 100
            });
        },
        defaultUserProfile,
        resetUserProfile: resetUserProfile,
        TKUIMapView: {
            props: (props: TKUIMapViewProps) => {
                const { trip, tripSegment } = props;
                const mapTiles = tripSegment ? tripSegment.mapTiles : trip?.mainSegment?.mapTiles;
                const mapTilesProps = mapTiles ?
                    {
                        tileLayerProps: {
                            attribution: mapTiles.sources
                                .map(source => `<a href=${source.provider.website} tabindex='-1'>${source.provider.name}</a>`)
                                .join(" | "),
                            url: mapTiles.urlTemplates[0]
                        }
                    } :
                    {
                        mapboxGlLayerProps: {
                            accessToken: "pk.eyJ1IjoibWdvbWV6bHVjZXJvIiwiYSI6ImNsbWw1MGowNjA3cXoydHBxNWV5YjIzbWsifQ.gN5TcKlZhy-iplwPV9R1Rw",
                            style: props.theme.isLight ?
                                "mapbox://styles/mgomezlucero/ckjliu0460xxh1aqgzzb2bb34" :
                                "mapbox://styles/mgomezlucero/ckbmm6m0w003e1hmy0ksjxflm",
                            attribution: "<a href='http://osm.org/copyright' tabindex='-1'>OpenStreetMap</a>"
                        }
                    };
                const onLocationClick = (loc: TKLocation) => {
                    props.onToChange?.(loc);
                };
                const children = bringThePaintLocations.map((loc: FacilityLocation, i) => {
                    if (props.to === loc) {
                        return null;
                    }
                    return (
                        <RoutingResultsContext.Consumer key={loc.getKey() || i}>
                            {({ viewport }) =>
                                viewport?.zoom && viewport.zoom >= 16 && <TKUIModeLocationMarker loc={loc} onClick={() => onLocationClick(loc)} key={loc.getKey() || i} />
                            }
                        </RoutingResultsContext.Consumer>
                    )
                });
                return {
                    ...mapTilesProps,
                    children
                };
            }
        },
        TKUITripPlanner: {
            props: (props) => ({
                renderTopRight: props.landscape ? () => <Logo style={{ height: '48px' }} />
                    : undefined
            })
        },
        TKUISidebar: {
            props: (props) => ({
                renderLogo: () => <Logo style={{ height: '48px' }} />,
                appStoreUrl: !isBeta ? 'https://apps.apple.com/us/app/choose-how-you-move/id1533929792' : undefined,
                playStoreUrl: !isBeta ? 'https://play.google.com/store/apps/details?id=uk.gov.leicester.chym' : undefined,
                appStoreImageUrl: !isBeta ? Constants.DEPLOY_URL + '/images/apple-store-logo.png' : undefined,
                playStoreImageUrl: !isBeta ? Constants.DEPLOY_URL + '/images/play-store-logo.png' : undefined,
                nativeAppsTitle: isBeta ? "Test beta mobile app:" : undefined,
                renderNativeAppLinks: isBeta ? () => (
                    <React.Fragment>
                        <div
                            onClick={() => window.open("https://testflight.apple.com/join/pNDtFY1z", '_blank')}
                            className={classNames(genClassNames.flex, genClassNames.alignCenter)}
                            style={{
                                height: '70px',
                                width: '144px',
                                cursor: 'pointer'
                            }}
                        >
                            <LogoTestflight style={{ height: '100%', marginRight: '15px' }} />
                            iOS app on TestFlight
                        </div>
                        <div
                            // onClick={() => window.open("https://play.google.com/store/apps/details?id=com.skedgo.client.feonix", '_blank')}
                            className={classNames(genClassNames.flex, genClassNames.alignCenter)}
                            style={{
                                height: '70px',
                                width: '170px',
                                cursor: 'pointer'
                            }}
                        >
                            <LogoGooglePlay style={{ height: '100%', marginRight: '15px' }} />
                            Android app on Google Play
                        </div>
                    </React.Fragment>
                ) : undefined
            })
        },
        TKUIProfileView: {
            props: {
                customSettings: () => {
                    return (
                        <TKUISettingSection>
                            <TKUISettingLink text={"Feedback & Support"}
                                onClick={() => window.open("https://www.leicester.gov.uk/contact-us/phone-and-email-us", "_blank")} />
                        </TKUISettingSection>
                    );
                }

            }
        },
        TKUIPrivacyOptionsView: {
            props: {
                privacyPolicyUrl: 'https://www.choosehowyoumove.co.uk/privacy'
            }
        },
        TKUIReportBtn: {
            render: (props) => { return null }
        },
        TKUILocationBox: {
            props: {
                menuMaxHeightPx: 400
            }
        },
        TKUITripOverviewView: {
            props: {
                actions: (trip, defaultActions) => defaultActions.concat([
                    <a referrerPolicy="no-referrer-when-downgrade" href='https://choosehowyoumove.betterpoints.uk/' target='_blank' style={{ textDecoration: 'none' }}>
                        <TKUIButton text={"Earn Rewards"}
                            icon={<img src={Constants.DEPLOY_URL + betterpointsLogo} style={{ height: '100%', width: '100%' }} />}
                            type={TKUIButtonType.SECONDARY_VERTICAL}
                        />
                    </a>
                ])
            }
        },
        TKUIServiceDepartureRow: {
            props: {
                showOperatorName: true
            }
        },
        TKUIIcon: {
            render: (props, defaultRender) => {
                switch (props.iconName) {
                    case "bringThePaint":
                        return (
                            <img
                                src={bringThePaintLogo}
                                style={{
                                    borderRadius: '50%',
                                    border: '1px solid black',
                                    padding: '1px',
                                    backgroundColor: 'white',
                                    width: '24px',
                                    height: 'auto'
                                }}
                            />
                        );
                    default:
                        return defaultRender(props);
                }
            }
        },
        ...whiteLabelConfigOverride
    };

    return (
        <TKRoot config={config} >
            <TKUITripPlanner userLocationPromise={userLocationPromise} />
            <TKStateUrl useHash={true} />
        </TKRoot >
    );
};

export default TripPlannerApp;